import {Component, Input, ViewChild} from '@angular/core';
import {ValidationHandlerService} from '../validation-handler.service';
import {AchooInputComponent} from '../achoo-input/achoo-input.component';
import {AchooColorPickerComponent} from '../achoo-color-picker/achoo-color-picker.component';
import {ColorPickerService} from 'ngx-color-picker';

@Component({
  selector: 'achoo-color-field',
  templateUrl: './achoo-color-field.component.html',
  styleUrls: ['./achoo-color-field.component.scss']
})
export class AchooColorFieldComponent extends AchooInputComponent<any> {

  @ViewChild('ColorPicker') colorPickerEle: AchooColorPickerComponent;

  @Input() color: string;
  @Input() priority: number;
  @Input() defaultColor: string;

  showColorPicker = false;

  constructor(protected validationHandlerService: ValidationHandlerService,
              private cpService: ColorPickerService) {
    super(validationHandlerService);
  }

  openColorPicker() {
    this.showColorPicker = true;
  }

  onClickOutside(evt) {
    const colorPicker = document.querySelector('#colorPickerContainer' + (this.priority || this.id));
    if (colorPicker && !colorPicker.contains(evt.target)) {
      this.color = this.colorPickerEle.originalColor;
      this.closeColorPicker();
    }
  }

  closeColorPicker() {
    this.showColorPicker = false;
  }

  onClickColorPicker() {
    if (this.showColorPicker) {
      this.closeColorPicker();
    } else {
      this.openColorPicker();
    }
  }

  onChangeColor(evt) {
    this.color = evt.color;
    const hexValue = this.convertToColorHex8(evt.color);
    if (evt.shouldClose) {
      this.onModelChange(hexValue);
      this.closeColorPicker();
    } else {
      this.model_ = hexValue;
    }
  }

  public convertToColorHex8(color: string): string {
    const hsva = this.cpService.stringToHsva(color, true);

    if (hsva) {
      return this.cpService.outputFormat(hsva, 'hex', null);
    }

    return '';
  }
}



// WEBPACK FOOTER //
// ./src/app/core/achoo-color-field/achoo-color-field.component.ts